import React from 'react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'

import ElementWrapper from 'designer/component/display/layout/control/ElementWrapper'
import DragElementWrapper from 'designer/component/system/layout/control/DragElementWrapper'

import CustomDivider from 'designer/component/element/Divider'

export const DividerSystem = (props) => (
  <DragElementWrapper {...props}>
    <CustomDivider {...props} />
  </DragElementWrapper>
)

export const DividerDisplay = (props) => (
  <ElementWrapper {...props}>
    <CustomDivider {...props} />
  </ElementWrapper>
)

export const dividerTester = rankWith(1000, scopeEndsWith('divider'))
